import { all, fork } from 'typed-redux-saga';
import watchCurrentCartActionsTrackingSaga from './watchCurrentCartActionsTrackingSaga';

function* cartTrackingSaga(): Generator {
  yield* all([fork(watchCurrentCartActionsTrackingSaga)]);
}

export default cartTrackingSaga;
